import React from 'react';
import Logo from '../../assets/SvgLogo';
import Rocked from '../../assets/SvgRocked';

const style = {
  fontWeight: 600,
  fontStyle: 'normal',
  fontSize: '24px',
  lineHeight: '36px',
  margin: 0,
};
const IconPage = () => (
  <>
    <div>
      <Logo />
    </div>
    <div>
      <Rocked />
    </div>

    <h2 style={style}>transforming</h2>
    <p style={style}>automotive sales</p>
  </>
);
export default IconPage;
